import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                name: null,
                email: null,
                password: Math.random().toString(36).slice(-8),
                phone: null,
                partner_id: null,
                toro_id: null,
                cemetery_id: null,
            },
            partners: [],
            toros: [],
            cemeteries: [],
        }
    },
    mutations: {
        setForm: (state, value) => {
            window.Vue.set(state, 'form', value);
        },
        setPartners: (state, value) => {
            window.Vue.set(state, 'partners', value);
        },
        setToros: (state, value) => {
            window.Vue.set(state, 'toros', value);
        },
        setCemeteries: (state, value) => {
            window.Vue.set(state, 'cemeteries', value);
        },
    },
    actions: {
        createMaster({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/master', form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        editMaster({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.update('/master/'+ form.id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        resetForm({state, commit}) {
            let form = {};

            Object.keys(state.form).forEach((property) => {
                form[property] = null;
            });

            form.password = Math.random().toString(36).slice(-8);

            commit('setForm', form);
        }
    }
};